import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { obtenerDetallePropuesta } from "../services/solicitudesService";

export default function DetalleParticipacion() {
  const { consecutivo, cedula } = useParams();
  const navigate = useNavigate();
  const [detalle, setDetalle] = useState(null);
  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [aprobado, setAprobado] = useState(false);

  useEffect(() => {
    obtenerDetallePropuesta(consecutivo)
      .then(data => {
        // Filtrar por cédula
        const filtrados = Array.isArray(data) ? data.filter(d => d.cedulaProveedor === cedula) : [];
        setDetalles(filtrados);
        setAprobado(false); // Aquí podrías poner lógica real de aprobado
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [consecutivo, cedula]);

  const mostrarDato = dato => (dato === null || dato === undefined || dato === "" || dato === 0)
    ? <span className="fst-italic text-muted">&lt;No indicado&gt;</span>
    : dato;

  const handleAprobar = () => {
    // Aquí iría la lógica real de aprobación (API)
    setAprobado(true);
  };

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-primary">Detalle de Participación</h2>
      {loading && <div className="alert alert-info">Cargando...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {detalles.length > 0 ? (
        <table className="table table-bordered mb-4">
          <thead>
            <tr>
              <th>Mes</th>
              <th>Año</th>
              <th>Horas</th>
              <th>Monto</th>
              <th>IVA</th>
              <th>Total</th>
              <th>Porcentaje</th>
              <th>Observaciones</th>
            </tr>
          </thead>
          <tbody>
            {detalles.map((d, i) => (
              <tr key={d.idDetalle || i}>
                <td>{mostrarDato(d.mes)}</td>
                <td>{mostrarDato(d.ano)}</td>
                <td>{mostrarDato(d.horasInvertidas)}</td>
                <td>{mostrarDato(d.monto)}</td>
                <td>{mostrarDato(d.iva)}</td>
                <td>{mostrarDato(d.total)}</td>
                <td>{mostrarDato(d.porcentaje)}</td>
                <td>{mostrarDato(d.observaciones)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="alert alert-warning">No hay desglose para este proveedor.</div>
      )}
      <button className="btn btn-success me-2" onClick={handleAprobar} disabled={aprobado}>Aprobar</button>
      <button className="btn btn-secondary" onClick={() => navigate(-1)}>Regresar</button>
    </div>
  );
}
